import { barba, PageState } from "barba"

const INDEX_PROP = 'popstate-index'
const PREVIOUS_INDEX_PROP = 'popstate-previous-index'
const DIRECTION_FOWARD = 1
const DIRECTION_BACK = -1
const DIRECTION_UNDEFINED = 0



// Vars
let direction = DIRECTION_UNDEFINED



// Get an index for the page history
function getIndex() {
    if (typeof PageState.get(INDEX_PROP) === "number") {
        return PageState.get(INDEX_PROP)
    }
    return null
}



// Get index of the last viewed page
function getPreviousIndex() {
    if (sessionStorage.getItem(PREVIOUS_INDEX_PROP)) {
        return parseInt(sessionStorage.getItem(PREVIOUS_INDEX_PROP))
    }
    return null
}



// Initialize on page load if no history state
if (getIndex() === null) {
    PageState.set(INDEX_PROP, getPreviousIndex() ? getPreviousIndex() + 1 : 0)
}



// On page load, reset last index to current
sessionStorage.setItem(PREVIOUS_INDEX_PROP, getIndex())


// Has soon there is a transition started, 
// update direction
barba.hooks.page(() => {
    const prevIndex = getPreviousIndex()
    let index = getIndex()

    if (index === null) {
        index = prevIndex + 1
    }
    
    if (prevIndex === null) {
        direction = DIRECTION_UNDEFINED
    }
    else if (prevIndex < index) {
        direction = DIRECTION_FOWARD
    }
    else if (prevIndex > index) {
        direction = DIRECTION_BACK
    }
    else {
        direction = DIRECTION_UNDEFINED
    }

    PageState.set(INDEX_PROP, index)
    sessionStorage.setItem(PREVIOUS_INDEX_PROP, index)
})



// Export helpers fuction
const isTriggerFoward = () => direction === DIRECTION_FOWARD
const isTriggerBack = () => direction === DIRECTION_BACK

export { isTriggerFoward, isTriggerBack }
export default { isTriggerFoward, isTriggerBack }
